import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { GetUserCompany } from 'src/app/models/company/get-company';
import { GetAddress } from 'src/app/models/security/register-request';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { FileStorageService } from 'src/app/services/file-storage.service';
import { UserService } from 'src/app/services/user.service';
import { CandidateService } from 'src/app/services/candidate.service';
import { Paged } from 'src/app/models/shared/paged';
import { GetCandidate, GetCandidateInJobOffer } from 'src/app/models/candidate/get-candidate';
import { GetUserFilter } from 'src/app/models/security/get-user-filter';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-main-companies',
  templateUrl: './main-companies.component.html',
  styles: [],
  standalone: true,
  imports: [CommonModule, CarouselComponent, RouterLink]
})
export class MainCompaniesComponent implements OnInit {
  items: any[] = [{
    logo: 'assets/Images/logo-compania.jpg',
    oferta: 'Desarrollador Android / IOS',
    compania: 'Inversion Futuro SRL',
    tiempo: 'Tiempo Completo',
    date: '28/May/2024',
    location: 'Santo Domingo'
  }, {
    logo: 'assets/Images/logo-compania.jpg',
    oferta: 'Desarrollador Frontend en Angular',
    compania: 'Tecnologias y Desarrollo SRL',
    tiempo: 'Tiempo Completo',
    date: '26/May/2024',
    location: 'Santo Domingo'
  }];

  isLoading: boolean = false;
  isFound: boolean = false;
  company: GetUserCompany | null | undefined = null;
  addresses: GetAddress[] = [];

  logo: string = 'assets/Images/logo-compania.jpg';

  authService = inject(AuthService);
  alertService = inject(AlertService);
  userService = inject(UserService);
  docService= inject(FileStorageService);
  candidateService = inject(CandidateService);

  principalAddress: GetAddress | undefined | null = null;
  userId: number = this.authService.getUserId() || 0;

  candidates: GetCandidateInJobOffer[] = [];
  apiFilters: GetUserFilter = {
    page: 1,
    pageSize: 10,
    filterKey: 'ownerUserId',
    filterValue: this.userId.toString()
  };


  constructor() { }

  ngOnInit(): void {
    this.getCompaData();
    this.loadCandidates();
  }

  getCompaData(): void {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getUserCompany(userId).subscribe({
      next: (res) => {
        this.company = res;
        if (res) {
          this.isFound = true;
          this.logo = this.docService.getFileUrl(`${res.logoFileId}`);
          this.getAddresses();
        }
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar la información de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  getAddresses() {
    const userId: number = this.authService.getUserId() || 0;

    this.isLoading = true;

    this.userService.getAddresses(userId).subscribe({
      next: (res) => {
        this.addresses = res;
        if (res && res.length > 0) {
          this.principalAddress = res.find((address) => address.isPrimary);
          if (!this.principalAddress) {
            this.principalAddress = res[0];
          }
        } 
      },
      error: (err) => {
        if (err) {
          this.alertService.showErrorAlert(err[0]);
        } else {
          this.alertService.showErrorAlert('Error al consultar las direcciones de la cuenta');
        }
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  loadCandidates(): void {
      this.isLoading = true;
      
      
      this.candidateService.getCandidatesInJobOffer(this.apiFilters).subscribe({
        next: (response: Paged<GetCandidateInJobOffer>) => {
          this.candidates = response.items.map((candidate: GetCandidateInJobOffer) => {
            let photoUrl = 'assets/Images/user.png';
            if (candidate.photoFileId) {
              photoUrl = this.docService.getFileUrl(candidate.photoFileId.toString());
            }
            
            return {
              ...candidate,
              photoUrl: photoUrl
            };
          });
          
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error al cargar profesionales independientes:', error);
          this.isLoading = false;
        }
      }).add(() => {
        this.isLoading = false;
      });
    }

}
